import { useLocation } from "react-router-dom";
import { CanineHeader, CanineFooter } from "./CanineShell";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { AskEon } from "./AskEon";

export function Layout({ children }) {
 const { pathname } = useLocation();
 const canine = /^\/(boerboels|dogs|breeders|shop|breeds|community|membership|trust-safety)(\/|$)/.test(pathname) || /^\/academy\/(course_ownership-foundations|course_puppy-prep-nutrition|course_structure-health-breeding)\/?$/.test(pathname) || /^\/programs\/(protection-trained-boerboels|board-and-train|elite-stud-service)\/?$/.test(pathname);
  return (
    <div className="min-h-screen flex flex-col bg-eon-bg">
      {canine ? <CanineHeader /> : <Navbar />}
      <main className="flex-1">{children}</main>
      {canine ? <CanineFooter /> : <Footer />}
      <AskEon />
    </div>
  );
}

export function PageHeader({ label, title, subtitle, children }) {
  return (
    <div className="border-b border-eon-border bg-eon-surface/40">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8 py-14 lg:py-20">
        {label && <div className="eon-label mb-4">{label}</div>}
        <h1 className="eon-heading text-4xl sm:text-5xl lg:text-6xl uppercase max-w-4xl">{title}</h1>
        {subtitle && <p className="mt-5 text-base text-eon-text/70 max-w-2xl leading-relaxed">{subtitle}</p>}
        {children}
      </div>
    </div>
  );
}
